import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// Import reducers
import authReducer from "./slices/authSlice";
import adminReducer from "./slices/adminSlice";
import settingsReducer from "./slices/settingsSlice";
import codeGenerationReducer from "./slices/codeGenerationSlice";
import silaeVariablesReducer from "./slices/silaeVariablesSlice";
import aiChatReducer from "./slices/aiChatSlice";
import aiConfigReducer from "./slices/aiConfigSlice";
import aiCreditsReducer from "./slices/aiCreditsSlice";

// Combine reducers
const rootReducer = combineReducers({
  auth: authReducer,
  admin: adminReducer,
  settings: settingsReducer,
  codeGeneration: codeGenerationReducer,
  silaeVariables: silaeVariablesReducer, // NOT persisted - loaded fresh on each reload
  aiChat: aiChatReducer,
  aiConfig: aiConfigReducer, // admin-only, not persisted
  aiCredits: aiCreditsReducer, // NOT persisted - solde rechargé à la demande
  // Add other reducers here
});

// Configuration simple de persistance
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "admin", "settings", "codeGeneration"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/REGISTER",
        ],
      },
    }),
});

export const persistor = persistStore(store);

// Export types for TypeScript
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
